<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  if(document.getElementById('fromDate')) { 
  
  /* Partie administrable */
  let dateDebut = 4,
      dateFin = 8,
      livraisonSamedi = "non";  
  /* Fin - Partie administrable */
  
 let fromDateTimestamp = new Date().getTime() + 24 * dateDebut * 3600 * 1000,      
      fromDateDay = new Date(fromDateTimestamp).getDate(),
      fromDateMonth = new Date(fromDateTimestamp).getMonth(),
      toDateTimestamp = new Date().getTime() + 24 * dateFin * 3600 * 1000,
      toDateDay = new Date(toDateTimestamp).getDate(),       
      toDateMonth = new Date(toDateTimestamp).getMonth(); 
  
      fromDateMonth = (fromDateMonth < 9 ? '0' : '') + parseFloat(fromDateMonth  + 1);
      toDateMonth = (toDateMonth < 9 ? '0' : '') + parseFloat(toDateMonth  + 1);  
  const checkIfWe = day => {   
    console.log(new Date(fromDateTimestamp).getDay())
    if(new Date(fromDateTimestamp).getDay() === 6) {
     
      if(day === 1) {       
        fromDateDay = fromDateDay;
        toDateDay = toDateDay + 1;    
      } else {
        fromDateDay = fromDateDay + 2;
        toDateDay = toDateDay + 3;    
      }
    } 
  } 
  
  livraisonSamedi === "oui" ? checkIfWe(1) : checkIfWe(2);   

  document.getElementById('fromDate').innerHTML =`${fromDateDay}/${fromDateMonth}`;
  document.getElementById('toDate').innerHTML =`${toDateDay}/${toDateMonth}`;  
  document.querySelector('.dg_shipping-date').style.display = 'block';  
}



  // va permettre créer un sommaire sur les h2
  const createSummary = function(t,h,nb,pos){            
    // on va chercher tous les H2
    const titles = document.querySelectorAll(h);  
    let statut = false;
    if (titles.length >= nb ) {
      statut = true;           
    }  
    if (statut) {
      let arrayTitlesText = [];  
      let i;
      // on boucle pour ajouter des ids différents et récupérer le texte des titres              
      for(i=0; i < titles.length; i++){
        const title = titles[i];
        title.id = `ancre-${i}`;
        arrayTitlesText.push(title.textContent);         
      }              
      // on crée le sommaire    
      const summaryWrapper = document.createElement('div');
      summaryWrapper.id = "summary";          
      const summaryTitle = document.createElement('strong');
      summaryTitle.textContent = t;
      summaryWrapper.appendChild(summaryTitle);
      const ul = document.createElement('ul');
      ul.id = "summary-list";
      summaryWrapper.appendChild(ul);
      // on récupère le texte des titres et on crée la liste à puce
      for(i=0; i < arrayTitlesText.length; i++){            
        const linkTitle = arrayTitlesText[i];                 
        const addLi = document.createElement('li');
        const findList = document.getElementById('summary-list');            
        const insertLi = ul.appendChild(addLi);
        const createLink = document.createElement('a');
        createLink.href = `#ancre-${i}`;    

        createLink.addEventListener('click', function (event) {
    event.preventDefault();

    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
        const offset = -80; // Adjust this value as needed
        const rect = targetElement.getBoundingClientRect();
        const targetPosition = window.scrollY + rect.top + offset;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
});

        
        const insertLink = insertLi.appendChild(createLink);
        insertLink.innerHTML = `${i +1}. ${linkTitle}`; 
      }
      // on trouve le chapo pour définir le placements        
      const chapo = document.querySelector('.chapo');
      // options 
      if (pos == "before") {
        chapo.before(summaryWrapper); 
      }  
      else if (pos == "after") {
        chapo.after(summaryWrapper); 
      }
      else {
        const postTitle = document.querySelector('h1');
        postTitle.after(summaryWrapper); 
      }    
    }   
  }
  /* options modifiables :
Option 1: titre du sommaire 
Option 2: balise à prendre en compte pour les ancres 
Option 3: Nombres de titres pour que le sommaire s'affiche
Option 4: placement du sommaire, choix: before, after, si vide se place sous le H1
ps: si choix before ou after mettre une class="chapo" sur votre 1er paragraphe dans votre éditeur shopify
*/
  const option1 = "Sommaire";
  const option2 = "h2";
  const option3 = "3";
  const option4 = "after";

  createSummary(option1,option2,option3,option4);



function toggleText() {
  var longTextContainer = document.querySelector('.long-text-container');
  var hiddenText = document.querySelector('.hidden-text');
  var readMoreButton = document.querySelector('.read-more-button');

  if (hiddenText.style.display === 'none' || hiddenText.style.display === '') {
    hiddenText.style.display = 'block';
    longTextContainer.style.maxHeight = 'none';
    readMoreButton.innerText = 'Réduire';
  } else {
    hiddenText.style.display = 'none';
    longTextContainer.style.maxHeight = '200px'; // Adjust to the original max height
    readMoreButton.innerText = 'Lire la suite';
  }
}